import { inject, type InjectionKey } from 'vue'
import de from './locales/de'
import en from './locales/en'

export type Locale = 'de' | 'en'
export type Messages = Record<string, string>

const locales: Record<Locale, Messages> = { de, en }

export type TranslateFn = (key: string, params?: Record<string, string | number>) => string

/**
 * Injection key used by OnlineSurvey.ce.vue (provide) and child components (inject).
 */
export const I18N_KEY: InjectionKey<TranslateFn> = Symbol('i18n')

/**
 * Creates a translation function for the given locale.
 * Supports simple named placeholders: t('redirectingIn', { n: 3, s: 's' })
 */
export function createTranslator(locale: Locale): TranslateFn {
  const messages = locales[locale] ?? locales['de']
  return function t(key, params) {
    let text: string = messages[key] ?? key
    if (params) {
      for (const [k, v] of Object.entries(params)) {
        text = text.replace(new RegExp(`\\{${k}\\}`, 'g'), String(v))
      }
    }
    return text
  }
}

/**
 * Use inside any child component to access translations.
 * Falls back to German when no provider is found.
 */
export function useI18n() {
  const t = inject(I18N_KEY) ?? createTranslator('de')
  return { t }
}

